import { MeetingFile } from 'src/core/types';

import axios from './axios';
import { downloadFileFromUrl } from 'src/utils/downloadFile';

export interface UseDownloadMeetingFilesProps {
  roomAddress: string;
}

export function useDownloadMeetingFiles(props: UseDownloadMeetingFilesProps) {
  const { roomAddress } = props;

  return {
    downloadMeetingFile: async (meetingFile: MeetingFile) => {
      const address = `https://media1.gharar.ir/rooms/${roomAddress}/files/${meetingFile.object_name}`;

      const downloadUrl = await axios
        .get<{ token: string }>(address)
        .then((res) => `${address}?token=${res.data['token']}`);

      downloadFileFromUrl(downloadUrl, meetingFile.name);
    },
  };
}
